import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { addMapMode } from 'client/store/mapSlice/mapSlice';
import { setDrawType } from 'client/store/drawSlice/drawSlice';
import { setAlertProps } from 'client/store/alertSlice/alertSlice';
import PropTypes from 'prop-types';
import Button from 'client/components/GDS/Button/Button';
import drawPolygon from 'client/assets/imgs/drawPolygon.svg';
import { BOX, CIRCLE, POLYGON } from 'client/utils/constants/symbolName';
import { mapModes } from 'client/utils/constants/appStates';
import { VALID_MODES } from './DrawButton.mode';
import styles from './LegacyDrawButton.module.scss';
import { permissions } from 'client/utils/constants/permissions';
import { useHasUserPermission } from 'client/utils/auth/userPermissions';
import mapModeIsValid from '../validateModes';
import Icon from '@mdi/react';
import { mdiVectorSquareEdit } from '@mdi/js';
import { DESKTOP } from 'client/utils/constants/GDS/js/devices';
import useDeviceType from 'client/utils/helpers/DeviceType/useDeviceType';
import { useMapScale } from 'client/pages/MapPage/hooks/useMapScale';
import { MAX_SCALE } from 'client/pages/MapPage/layers/constants';
import { useClearAOI } from 'client/pages/MapPage/hooks/clearAOI';
const { DRAWING, LOADING, MODIFYING } = mapModes;

const DrawButton = ({
    mapMode,
    addMapMode,
    drawStatus,
    setDrawType,
    disableAboveMaxScale,
    type,
    setAlertProps,
    setCreateMobileAOIDialog,
    ...props
}) => {
    const deviceType = useDeviceType();

    const scale = useMapScale();
    const isActivelyEditingAoi = mapMode.includes(DRAWING) || mapMode.includes(MODIFYING);
    const disabled = disableAboveMaxScale && scale > MAX_SCALE;
    const isDisabled = disabled || isActivelyEditingAoi || mapMode.includes(LOADING) || (drawStatus.length > 0 && isActivelyEditingAoi);
    const clearAOI = useClearAOI();

    const handleDraw = () => {
        clearAOI();
        addMapMode(DRAWING);
        if (deviceType === DESKTOP) {
            setDrawType(type);
            setAlertProps({
                open: true,
                severity: 'info',
                content: <FormattedMessage id='mapToolbar.startDrawing' />
            });
        } else {
            setCreateMobileAOIDialog(true);
        }
    };
    let buttonText = type;
    let buttonIcon;
    if (type === BOX) {
        buttonText = <FormattedMessage id="mapToolbar.drawButton.box"/>;
        buttonIcon = <Icon path={mdiVectorSquareEdit} size={0.7}/>;
    } else if (type === POLYGON) {
        buttonText = <FormattedMessage id="mapToolbar.drawButton.polygon"/>;
        buttonIcon = <img src={ drawPolygon } className={ styles.svg } alt=""/>;
    }
    const hasPermission = useHasUserPermission(permissions.AOI_DRAW);

    return (hasPermission && mapModeIsValid(mapMode, VALID_MODES))
        ? <><Button
            variant="info"
            onClick={handleDraw}
            disabled={isDisabled}
            {...props}
        >
            {buttonIcon}
            {buttonText}

        </Button>
        </>
        : null;
};

DrawButton.propTypes = {
    mapMode: PropTypes.array,
    addMapMode: PropTypes.func,
    setDrawType: PropTypes.func,
    drawStatus: PropTypes.array,
    setAlertProps: PropTypes.func,
    disableAboveMaxScale: PropTypes.bool,
    setCreateMobileAOIDialog: PropTypes.func,
    type: PropTypes.oneOf([POLYGON, CIRCLE, BOX]).isRequired
};

DrawButton.defaultProps = {
    mapMode: [],
    addMapMode: () => {},
    setDrawType: () => {},
    drawStatus: [],
    setAlertProps: () => {},
    disableAboveMaxScale: false,
    setCreateMobileAOIDialog: () => {}
};

const mapStateToProps = state => {
    const { map, draw } = state;
    return {
        mapMode: map?.mode || [],
        drawStatus: draw?.status || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addMapMode: (payload) => dispatch(addMapMode(payload)),
        setDrawType: (payload) => dispatch(setDrawType(payload)),
        setAlertProps: (payload) => dispatch(setAlertProps(payload))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawButton);
